import React from 'react';
import CommonErrorPage from '../Common/CommonErrorPage';
import { Error6 } from '../../Common/CommonPageIcon';

export default function ErrorPage6() {
   return (
      <CommonErrorPage
         title="No tienes permiso para acceder a esta página"
         errorIcon={<Error6 />}
      />
   );
}
